import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Products } from './components/Products';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Shipping } from './components/Shipping';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="relative min-h-screen bg-dark text-text-main font-inter selection:bg-neon-pink/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <Products data-id="element-4" />
      <Process data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Shipping data-id="element-7" />
      <Contact data-id="element-8" />
      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}